import { render, staticRenderFns } from "./ServiceDetailTabsDeliveryProof.vue?vue&type=template&id=82b9910c&scoped=true&"
import script from "./ServiceDetailTabsDeliveryProof.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailTabsDeliveryProof.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetailTabsDeliveryProof.vue?vue&type=style&index=0&id=82b9910c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b9910c",
  null
  
)

export default component.exports